import React from "react";
import PropTypes from "prop-types";
//limitless imports
import MessageConversationCompleteDialog from "../../dialogs/message-conversation-complete-dialog/MessageConversationCompleteDialog";
import ConversationComplete from "@limitless/icons/ConversationComplete";
import Typography from "@limitless/modern/data-display/typography/Typography";
const classes = {
  conversationEndedAnchorContainer: {
    display: "flex",
    flexDirection: "row-reverse",
    width: "90%",
    flex: 1,
    paddingRight: 8,
    paddingTop: 8,
    paddingBottom: 12
  },
  translationMessage: {
    display: "flex",
    flexDirection: "row"
  },
  rootTypographyClipboard: {
    cursor: "pointer",
    marginLeft: 4
  }
};
const ConversationEndedAnchor = ({
  message
}) => {
  const [showConversationComplete, setShowConversationComplete] = React.useState(false);
  const {
    conversationState,
    dialogues
  } = message;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: classes.conversationEndedAnchorContainer
  }, conversationState.showCustomerConfirmation && /*#__PURE__*/React.createElement(Typography, {
    style: classes.translationMessage,
    variant: "body2",
    sx: {
      color: theme => theme.palette.text.primary
    }
  }, "Has the conversation ended?", /*#__PURE__*/React.createElement(Typography, {
    style: classes.rootTypographyClipboard,
    variant: "body",
    sx: {
      color: theme => theme.palette.primary.main
    },
    onClick: () => setShowConversationComplete(true),
    id: "conversationComplete"
  }, "Mark it as complete")), !conversationState.showCustomerConfirmation && dialogues[dialogues.length - 1].type === "custConfirmation" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConversationComplete, {
    color: "primary",
    sx: {
      paddingLeft: "10px"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    style: classes.translationMessage,
    variant: "body2",
    sx: {
      color: theme => theme.palette.text.primary
    }
  }, "Conversation Complete!"))), showConversationComplete && /*#__PURE__*/React.createElement(MessageConversationCompleteDialog, {
    onCancel: () => setShowConversationComplete(false)
  }), " ");
};
export default ConversationEndedAnchor;
ConversationEndedAnchor.propTypes = {
  message: PropTypes.object.isRequired
};